import { useState, useCallback } from 'react';

export default function useSidebarCollapse() {
  const [isCollapsed, setIsCollapsed] = useState(() => {
    try {
      return localStorage.getItem('sidebar-collapsed') === 'true';
    } catch {
      return false;
    }
  });

  const toggleCollapse = useCallback(() => {
    setIsCollapsed((prev) => {
      const next = !prev;
      try {
        localStorage.setItem('sidebar-collapsed', String(next));
      } catch { /* ignore */ }
      return next;
    });
  }, []);

  const expand = useCallback(() => {
    setIsCollapsed(false);
    try {
      localStorage.setItem('sidebar-collapsed', 'false');
    } catch { /* ignore */ }
  }, []);

  return { isCollapsed, toggleCollapse, expand };
}
